module.exports = __webpack_public_path__ + "static/media/TUNE_6452.b9db4a0b.jpg";